import { render, staticRenderFns } from "./JDMatchingList.vue?vue&type=template&id=445b9bf4&scoped=true&"
import script from "./JDMatchingList.vue?vue&type=script&lang=js&"
export * from "./JDMatchingList.vue?vue&type=script&lang=js&"
import style0 from "./JDMatchingList.vue?vue&type=style&index=0&id=445b9bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b9bf4",
  null
  
)

export default component.exports